/**
 * Import required libraries
 */
import React from "react";
import { connect } from "react-redux";
import { removeLocalItem } from "Utils";

/**
 * Import required elements
 */
import MenuProfileRender from "./render";

/**
 * MenuProfile Component
 */
function MenuProfile(props) {
  function settings(event) {
    props.handleClose(event);
  }

  function disconnect(event) {
    removeLocalItem("userToken");
    props.dispatch({ type: "DISCONNECTION" });
    window.location.reload(true);
  }

  let { lang, pseudo, menuIsOpen, handleClose, buttonRef } = props;

  return React.createElement(MenuProfileRender, {
    pseudo,
    disconnect,
    settings,
    lang,
    menuIsOpen,
    handleClose,
    buttonRef
  });
}

/**
 * Export component
 */
// map redux state to props
export default connect((state, { userUid }) => {
  let mapstate = {
    socket: state.simtopy.socket,
    lang: state.locale.lang
  };
  if (userUid && state.list.user[userUid]) {
    mapstate.pseudo = state.list.user[userUid].pseudo;
  }
  return mapstate;
})(MenuProfile);
